document.addEventListener('DOMContentLoaded', () => {
    ACCORDEON.onReady();
    BLOG.onReady();
    CALENDLY.onReady();
    CLEAN.onReady();
    FORM.onReady();
    NAV.onReady();
    OVERLAY.onReady();
    TINYSLIDER.onReady();
    TOOLTIP.onReady();
    TRACKING.onReady();
    VIDEO.onReady();
});